<panel width="400">
	@if (!dashboardElement) {
		<skeleton />
	}
	@if (dashboardElement) {
		<h1>{{ (dashboardElement.id ? 'dashboard.headline.edit' : 'dashboard.headline.create') | translate }}</h1>
		<section>
			<custom-input [label]="'dashboard.name' | translate" [(value)]="dashboardElement.name" [required]="true" />
			<custom-input [label]="'dashboard.description' | translate" [(value)]="dashboardElement.description" [inputType]="inputType.Textarea" />
			<custom-select [label]="'dashboard.type' | translate" [(value)]="dashboardElement.type" [selectList]="dashboardTypesList" [required]="true" />
			@if (dashboardElement.type == dashboardType.Information) {
				<custom-input [label]="'dashboard.information-header' | translate" [(value)]="dashboardElement.configuration!.header" />
				<custom-input [label]="'dashboard.information-content' | translate" [(value)]="dashboardElement.configuration!.content" [inputType]="inputType.Editor" />
			}
		</section>
		<h2>{{ 'dashboard.teams' | translate }}</h2>
		<list-view scrollable [selectable]="false">
			<header defaultSort="descending"></header>
			<header>{{ 'general.name' | translate }}</header>
			<header>{{ 'dashboard.team.sale' | translate }}</header>
			<row *listData="let team from teams" (action)="selectTeam(team)">
				<column [sortValue]="team.wasSelected"><input type="checkbox" [(checked)]="team.selected" /></column>
				<column>{{ team.name }}</column>
				<column>{{ 'general.' + team.sale | translate }}</column>
			</row>
		</list-view>
		<section>
			<button confirm #saveButton (click)="save()">{{ 'general.save' | translate }}</button>
		</section>
	}
</panel>
